import * as signalR from '@microsoft/signalr';
import { DEVSTRING } from './constant.utils';

const hubURL = process.env.NODE_ENV !== DEVSTRING ? process.env.REACT_APP_NOTIFICATION_HUB_ADDRESS : "http://localhost:52919/notification-hub";

class NotificationHubConnector {
    #connection;
    connectionName;
    connectionArgs;
    events = (_onHeaderNotificationReceived = (_notifications) => void (0)) => void (0);
    static instance;

    constructor(connectionName, connectionArgs) {
        this.connectionName = connectionName;
        this.connectionArgs = connectionArgs;

        this.#connection = new signalR.HubConnectionBuilder()
            .withUrl(hubURL, {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets
            })
            .withAutomaticReconnect()
            .build();

        this.#connection.start()
            .then(() => {
                this.#connection.invoke(connectionName, connectionArgs);
            })
            .catch(err => console.log(err));

        this.events = (onHeaderNotificationReceived = (_notifications) => void (0)) => {
            this.#connection.on("ReceiveHeaderNotification", (notifications) => {
                onHeaderNotificationReceived(notifications);
            });
        }
    }

    callMethod = (methodName, args = {}) => {
        if (this.#connection !== null) {
            this.#connection.invoke(methodName, args)
                .catch(err => console.log(err));
        }
    }

    closeConnection = () => {
        if (this.#connection !== null) {
            this.#connection.stop();
        }
    }

    static getInstance = (connectionName, connectionArgs) => {
        const _instance = NotificationHubConnector.instance;
        if (!_instance || (_instance && _instance.connectionName != connectionName && _instance.connectionArgs != connectionArgs)) {
            return NotificationHubConnector.instance = new NotificationHubConnector(connectionName, connectionArgs);
        }
        else {
            return NotificationHubConnector.instance;
        }
    }
}

export default NotificationHubConnector.getInstance;